import { render } from "./AdcComp.vue?vue&type=template&id=62cfd170&scoped=true"
import script from "./AdcComp.vue?vue&type=script&lang=js"
export * from "./AdcComp.vue?vue&type=script&lang=js"

import "./AdcComp.vue?vue&type=style&index=0&id=62cfd170&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cfd170"]])

export default __exports__